// extracted by mini-css-extract-plugin
export var clickableOverlay = "Modal-module--clickableOverlay--73d14";
export var description = "Modal-module--description--ff5dc";
export var headerContent = "Modal-module--headerContent--c0bc6";
export var headerWrapper = "Modal-module--headerWrapper--999dc";
export var modal = "Modal-module--modal--dc69f";
export var modalList = "Modal-module--modalList--b65c6";
export var modalWrapper = "Modal-module--modalWrapper--7a903";
export var share = "Modal-module--share--19657";
export var title = "Modal-module--title--19d09";